var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"map-cell",class:{highlight: _vm.highlight, 'dark-mode':_vm.darkMode}},[_vm._v(_vm._s(_vm.symbol))])
}
var staticRenderFns = []

export { render, staticRenderFns }